const DEFAULT_SETTINGS = {
  /*
  fieldId: { // Same ID as supplied to <Input />
    value: '',
    defaultValue: '', // Update StepReview.jsx & relevant step(s) if you need to output
  }
  */
  /* Default Advanced Settings */
  throttleEnabled: {
    value: false
    // We want to default to true on render, but never compare the default
  },
  sophosName: {
    value: ""
  },
  sophosThrottleEnabled: {
    value: void 0
  },
  pollingInterval: {
    value: 5
  },
  ingestAlerts: {
    value: false
  }
};
export default DEFAULT_SETTINGS;
